import { Box, Grid, Typography } from "@mui/material";
import data from "../errorcodes.json";
import Parameters from "../Components/Parameters";
import { useEffect } from "react";
import { Helmet } from "react-helmet";

export default function ErrorCodes() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  return (
    <>
      <Helmet>
        <title>Error Codes</title>
      </Helmet>
      <Box className="introduction-page">
        <Grid container spacing={0}>
          <Grid item xs={12} md={9} sm={12} lg={9}>
            <Box className="introduction-page-left">
              <Typography id="intro-title-label">
                Error Code & Description
              </Typography>
              <Typography
                sx={{ mb: 3 }}
                variant="subtitle2"
                id="intro-title-para"
              >
                Refer the following table for Error Description
              </Typography>
              <Parameters data={data} />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
